var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSave2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_30598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 3.95166H5C3.89 3.95166 3 4.85166 3 5.95166V19.9517C3 21.0517 3.89 21.9517 5 21.9517H19C20.1 21.9517 21 21.0517 21 19.9517V7.95166L17 3.95166ZM19 19.9517H5V5.95166H16.17L19 8.78166V19.9517ZM12 12.9517C10.34 12.9517 9 14.2917 9 15.9517C9 17.6117 10.34 18.9517 12 18.9517C13.66 18.9517 15 17.6117 15 15.9517C15 14.2917 13.66 12.9517 12 12.9517ZM6 6.95166H15V10.9517H6V6.95166Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_30598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.95166)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSave2);
export default __webpack_public_path__ + "static/media/icon_save2.5f89aaa5ba8de3cf3159f681875effd0.svg";
export { ForwardRef as ReactComponent };